module.exports = __webpack_public_path__ + "images/symbols.svg";


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/symbols.svg
// module id = 259
// module chunks = 2